import { useRequest, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import { observer, useLocalStore, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import NewEditForm from '@/components/NewEditForm'
import { useCommonForm } from '@/hooks'
import jobStore from '@/store/components/entryJob'
import dictStore from '@/store/global/dictStore'
import { getDateTextHandler, mapValuesAndTexts } from '@/utils/index'

import HPopup from '../../HYBVant/HPopup'

import config from './config.json'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const { runSaveHealth, runDeleteHrmHealth, saveHealthLoading, deleteHrmHealthLoading } = modalData
  const [formIt] = Form.useForm()
  const { editHealthItem, employeeIds, healthCertificateStatus, changeAllHealthCertificate } =
    useLocalObservable(() => jobStore)
  const store = useLocalStore(() => dictStore)
  const health_type_options = store?.dictMap?.['HEALTH_CERTIFICATE_TYPE'] || []
  const onFinish = (fieldValues: any) => {
    if (saveHealthLoading || deleteHrmHealthLoading) return
    const fieldValue: any = {
      employee_ids: employeeIds
    }
    if (editHealthItem?.id && healthCertificateStatus === 'Edit') {
      fieldValue.id = editHealthItem?.id
    }
    fieldValue.healths = [
      {
        ...fieldValues,
        start_time: getDateTextHandler({
          dateInfo: fieldValues?.start_time,
          dateType: 'formatEchoDate'
        }),
        end_time: getDateTextHandler({
          dateInfo: fieldValues?.end_time,
          dateType: 'formatEchoDate'
        })
      }
    ]
    runSaveHealth(fieldValue)
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const health_type_value = health_type_options?.[0]?.value || null
      const fields = editHealthItem
      const start_time = fields?.health_start_at || ''
      const end_time = fields?.health_end_at || ''
      const health_imgs = fields?.health_certificates || fields?.health_certificate_list || []
      const health_type = fields?.health_type || health_type_value
      const health_certificates = health_imgs?.map((x: any) => x?.oss_key || x) || []
      const health_info = bool
        ? {
            start_time,
            end_time,
            health_certificates,
            health_type,
            id_number: fields?.id_number || '',
            city_id: fields.city_ids || fields.city_codes
          }
        : { health_type }
      formIt.setFieldsValue(health_info)
    }
    setFieldValues(healthCertificateStatus === 'Edit')
  }, [healthCertificateStatus, editHealthItem])
  const deleteInfo = () => {
    if (healthCertificateStatus === 'Edit') {
      const fields = editHealthItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteHrmHealth({ id: ids })
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }

  const { option, optionStatus } = useCommonForm({
    code: 'module_health_form',
    vars: {},
    immediate: true
  })

  return (
    <HPopup
      title='健康证'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {optionStatus === 'DONE' && (
        <NewEditForm
          formInst={formIt}
          formInfo={option?.formInfo ?? []}
          onFinish={onFinish}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      )}
    </HPopup>
  )
}

export default observer(HealthCertificate)
